export default "__VITE_ASSET__ZD6cf$8e__"